import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {selectTab} from './TabsActions'
import Tabs from './Tabs'
import {getTabs, getSelected} from "./TabsReducers";

const TabsContainer = ({tabs, selectTab, selected}) => {

  return (
    <aside id="menu">
      <div id="navigation">
        <Tabs
          tabs={tabs}
          selected={selected}
          onTabSelected={(tab) => selectTab(tab)}/>
      </div>
    </aside>
  );
};

TabsContainer.propTypes = {
  tabs: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  selectTab: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  tabs: getTabs(state),
  selected: getSelected(state)
});

export default connect(
  mapStateToProps,
  {selectTab}
)(TabsContainer);



// WEBPACK FOOTER //
// ./src/tabs/TabsContainer.js